window.KumoriHubPackSelector = function (sectionId) {
  'use strict';

  var raw = document.getElementById('ps-data-' + sectionId);
  if (!raw) return;
  var cfg      = JSON.parse(raw.textContent);
  var sid      = cfg.sid;
  var products = cfg.products;

  /* ── Money ── */
  var moneyFormat = (window.Shopify && window.Shopify.money_format) ? window.Shopify.money_format : cfg.moneyFormat;
  function money(cents) {
    cents = cents || 0;
    var amount           = (cents / 100).toFixed(2);
    var amountNoDec      = String(Math.round(cents / 100));
    var amountComma      = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amountNoDecComma = amountNoDec.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g,                                amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,                    amountNoDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,           amountComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecComma);
  }

  /* ── DOM refs ── */
  function el(id) { return document.getElementById(id); }
  var mainImg    = el('ps-main-img-' + sid);
  var imgWrap    = el('ps-img-wrap-' + sid);
  var videoWrap  = el('ps-video-wrap-' + sid);
  var thumbsEl   = el('ps-thumbs-' + sid);
  var peekImg    = el('ps-peek-img-' + sid);
  var peekWrap   = el('ps-peek-img-wrap-' + sid);
  var titleEl    = el('ps-title-' + sid);
  var subtitleMat= el('ps-subtitle-material-' + sid);
  var priceEl    = el('ps-price-' + sid);
  var thirdPriceEl = el('ps-third-price-' + sid);
  var debugEl    = el('ps-debug-' + sid);
  var compareEl  = el('ps-compare-' + sid);
  var saveBadge  = el('ps-save-' + sid);
  var qtyEl      = el('ps-qty-' + sid);
  var perEl      = el('ps-per-' + sid);
  var qtyRow     = el('ps-qty-row-' + sid);
  var colorVal   = el('ps-color-val-' + sid);
  var swatchWrap = el('ps-swatches-' + sid);
  var sizesWrap    = el('ps-sizes-' + sid);
  var sizeLabel    = el('ps-size-label-' + sid);
  var materialsWrap = el('ps-materials-' + sid);
  var materialLabel = el('ps-material-label-' + sid);
  var vidInput     = el('ps-vid-' + sid);
  var atcBtn     = el('ps-atc-' + sid);
  var prevBtn    = el('ps-prev-' + sid);
  var nextBtn    = el('ps-next-' + sid);
  var progressEl = el('ps-progress-' + sid);
  var sgBtn      = el('ps-sg-btn-' + sid);
  var sgModal    = el('ps-sg-modal-' + sid);
  
  var promoWrapper = el('ps-promo-wrapper-' + sid) || document.querySelector('#ps-' + sid + ' .ps__promo-badge-wrapper');
  var promoTextEl  = el('ps-promo-text-' + sid);
  
  // 🎥 Hero Video Reference
  var heroVideo  = el('ps-hero-video-' + sid);
  
  // 🚚 Delivery Dates Reference
  var deliveryDatesSpan = el('ps-delivery-dates-' + sid);
  
  // 🚨 Urgency Text Reference
  var urgencyContainer = el('ps-urgency-container-' + sid);
  var urgencyMsg       = el('ps-urgency-msg-' + sid);
  var urgencyTimerEl   = el('ps-urgency-timer-' + sid);

  /* ── FIX 6: DYNAMIC PERPETUAL URGENCY TIMER ── */
  if (urgencyTimerEl) {
    function updateTimer() {
      var now = new Date();
      var target = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 23, 59, 59);
      var diff = target - now;

      var d = Math.floor(diff / (1000 * 60 * 60 * 24));
      var h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      
      var dayStr = d === 1 ? " day " : " days ";
      var hrStr = h === 1 ? " hr " : " hrs ";
      var minStr = m === 1 ? " min" : " mins";
      
      urgencyTimerEl.textContent = d + dayStr + h + hrStr + m + minStr;
    }
    updateTimer(); 
    setInterval(updateTimer, 60000); 
  }

  /* ── State ── */
  var activePack    = cfg.defaultPack;
  var activeProduct = null;
  var imgList       = []; 
  var imgIdx        = 0;
  var touchStartX   = 0;
  var touchStartY   = 0;
  var sizeSelected  = false; 
  var isFirstLoad   = true; 

  /* ── Calculate Dynamic Delivery Window ── */
  function getDeliveryDateString(addDays) {
    var d = new Date();
    d.setDate(d.getDate() + addDays);
    var m = (d.getMonth() + 1).toString().padStart(2, '0');
    var day = d.getDate().toString().padStart(2, '0');
    return m + '/' + day;
  }
  if (deliveryDatesSpan) {
    deliveryDatesSpan.textContent = getDeliveryDateString(2) + ' - ' + getDeliveryDateString(7);
  }

  /* ── Clean Up Blank Urgency State ── */
  if (urgencyContainer && urgencyMsg) {
    if (urgencyMsg.textContent.trim() === '') {
      urgencyContainer.style.display = 'none';
    }
  }

  /* ── Hero Video Magic ── */
  function dismissHeroVideo() {
    if (heroVideo && heroVideo.style.display !== 'none') {
      heroVideo.style.display = 'none';
      var vid = heroVideo.querySelector('video');
      if (vid) vid.pause(); 
    }
  }

  /* ── Helpers ── */
  function packProducts(pack) {
    var packLower = (pack || '').toLowerCase();
    return products.filter(function (p) { return (p.pack_size || '').toLowerCase() === packLower; });
  }

  function defaultForPack(pack) {
    var list = packProducts(pack);
    return list.find(function (p) { return p.is_default; }) || list[0] || null;
  }

  /* ── Size mapping ── */
  function mapSizeLabel(sizeCode) {
    var sizeMap = {
      'S': 'Small',
      'M': 'Medium',
      'L': 'Large',
      'XL': 'X-Large',
      'XXL': 'XX-Large',
      'XXXL': 'XXX-Large',
      'XS': 'X-Small'
    };
    return sizeMap[sizeCode] || sizeCode;
  }

  /* ── Find variant by options (supports 2 or 3 options) ── */
  function findVariant(p, option1, option2, option3) {
    if (!p || !p.variants || !p.variants.length) return null;
    return p.variants.find(function (v) {
      var m1 = v.option1 === option1;
      var m2 = (v.option2 == null || v.option2 === '' || option2 == null) ? true : (v.option2 === option2);
      var m3 = (v.option3 == null || v.option3 === '' || option3 == null) ? true : (v.option3 === option3);
      return m1 && m2 && m3;
    }) || null;
  }

  function getCurrentVariant() {
    if (!activeProduct || !vidInput || !vidInput.value) return null;
    var id = parseInt(vidInput.value, 10);
    return activeProduct.variants.find(function (v) { return v.id === id; }) || null;
  }

  /* ── Progress bar ── */
  function renderProgress() {
    if (!progressEl) return;
    progressEl.innerHTML = '';
    imgList.forEach(function (_, i) {
      var dot = document.createElement('div');
      var classes = 'ps__gallery-progress-dot';
      if (i === imgIdx) classes += ' is-active';
      else if (i < imgIdx) classes += ' is-passed';
      dot.className = classes;
      progressEl.appendChild(dot);
    });
  }

  function syncProgress() {
    if (!progressEl) return;
    progressEl.querySelectorAll('.ps__gallery-progress-dot').forEach(function (dot, i) {
      dot.classList.remove('is-active', 'is-passed');
      if (i === imgIdx) {
        dot.classList.add('is-active');
      } else if (i < imgIdx) {
        dot.classList.add('is-passed');
      }
    });
  }

  /* ── Gallery: show image vs video ── */
  function showImage() {
    if (imgWrap)   imgWrap.style.display   = '';
    if (videoWrap) videoWrap.style.display = 'none';
    if (videoWrap) {
      var vid = videoWrap.querySelector('video');
      if (vid) vid.pause();
    }
  }

  function showVideo() {
    if (imgWrap)   imgWrap.style.display   = 'none';
    if (videoWrap) videoWrap.style.display = '';
    var vid = videoWrap ? videoWrap.querySelector('video') : null;
    if (vid) vid.play().catch(function(){});
  }

  function setImg(idx, initialLoad) {
    if (!imgList.length) return;

    idx = Math.max(0, Math.min(idx, imgList.length - 1));
    imgIdx = idx;
    var item = imgList[idx];
    
    if (item.type === 'hero_video') {
      if (heroVideo) {
        heroVideo.style.display = 'block';
        var vid = heroVideo.querySelector('video');
        if (vid) {
          if (!initialLoad) {
            vid.currentTime = 0;
            vid.play().catch(function(){});
          }
        }
      }
      showImage(); 
    } else {
      if (!initialLoad) dismissHeroVideo(); 
      
      if (item.type === 'video') {
        showVideo();
      } else {
        showImage();
        if (mainImg) { mainImg.src = item.src; mainImg.alt = item.alt; }
      }
      
      if (item.type === 'image' && item.src) {
        var nextIdx = idx + 1, prevIdx = idx - 1;
        if (nextIdx < imgList.length && imgList[nextIdx].type === 'image' && imgList[nextIdx].src) {
          var nextImg = new Image(); nextImg.src = imgList[nextIdx].src;
        }
        if (prevIdx >= 0 && imgList[prevIdx].type === 'image' && imgList[prevIdx].src) {
          var prevImg = new Image(); prevImg.src = imgList[prevIdx].src;
        }
      }
    }

    /* Mobile-peek: show next image (skipping non-image media, wrapping at end) */
    if (peekImg && peekWrap) {
      var len = imgList.length;
      var pIdx = -1;
      if (len > 1) {
        for (var step = 1; step < len; step++) {
          var cand = (idx + step) % len;
          if (cand === idx) break;
          if (imgList[cand] && imgList[cand].type === 'image' && imgList[cand].src) {
            pIdx = cand;
            break;
          }
        }
      }
      if (pIdx > -1) {
        peekImg.src = imgList[pIdx].src;
        peekImg.alt = imgList[pIdx].alt || '';
        peekWrap.style.display = '';
        peekWrap.setAttribute('data-peek-idx', String(pIdx));
      } else {
        peekWrap.style.display = 'none';
      }
    }
    
    if (thumbsEl) {
      thumbsEl.querySelectorAll('.ps__thumb').forEach(function (t, i) {
        t.classList.toggle('is-active', i === idx);
      });

      /* Mobile peek: programmatic auto-scroll to active slide. Disable scroll-snap
         AND scroll-behavior during the scrollLeft assignment so the browser doesn't
         animate the change (multi-pack-briefs.css sets scroll-behavior: smooth on
         .ps__thumbs which would otherwise animate every programmatic jump). Variant
         clicks should feel like an instant image change, not a scroll. User
         touch-scrolls keep their native smooth/snap feel because this path only
         runs when setImg() is invoked programmatically. */
      if (cfg.peekLayout && window.innerWidth <= 767) {
        var targetThumb = thumbsEl.querySelectorAll('.ps__thumb')[idx];
        if (targetThumb) {
          thumbsEl.style.setProperty('scroll-snap-type', 'none', 'important');
          thumbsEl.style.setProperty('scroll-behavior', 'auto', 'important');
          thumbsEl.scrollLeft = targetThumb.offsetLeft;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              thumbsEl.style.removeProperty('scroll-snap-type');
              thumbsEl.style.removeProperty('scroll-behavior');
            });
          });
        }
      }
    }
    syncProgress();
  }

  function renderThumbs(p) {
    if (!thumbsEl) return;
    thumbsEl.innerHTML = '';
    var newList = [];
    var thumbIdx = 0;

    if (cfg.heroVideoPreview) {
      var hvBtn = document.createElement('button');
      hvBtn.className = 'ps__thumb ps__thumb--hero-video' + (thumbIdx === 0 ? ' is-active' : '');
      hvBtn.type = 'button';
      hvBtn.innerHTML = '<img src="' + cfg.heroVideoPreview + '" alt="Play Video" class="ps-force-show" style="width: 100% !important; height: 100% !important; object-fit: cover !important; display: block !important; position: absolute !important; top: 0 !important; left: 0 !important;"><span class="ps__thumb-play"><svg viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" fill="rgba(0,0,0,0.5)"/><path d="M6.5 5.5L11 8L6.5 10.5V5.5Z" fill="white"/></svg></span>';
      
      var hi = thumbIdx++;
      newList.push({ type: 'hero_video' });
      hvBtn.addEventListener('click', function () { isFirstLoad = false; setImg(hi, false); });
      thumbsEl.appendChild(hvBtn);
    }

    p.images.forEach(function (img) {
      var btn = document.createElement('button');
      btn.className = 'ps__thumb' + (thumbIdx === 0 ? ' is-active' : '');
      btn.type = 'button';
      var thumbDisplaySrc = cfg.peekLayout ? img.src : img.thumb;
      btn.innerHTML = '<img src="' + thumbDisplaySrc + '" alt="' + img.alt + '" class="ps-force-show" style="width: 100% !important; height: 100% !important; object-fit: cover !important; display: block !important; visibility: visible !important; opacity: 1 !important; position: absolute !important; top: 0 !important; left: 0 !important;">';
      var ii = thumbIdx++;
      newList.push({ type: 'image', src: img.src, thumb: img.thumb, alt: img.alt });
      btn.addEventListener('click', function () { isFirstLoad = false; setImg(ii, false); });
      thumbsEl.appendChild(btn);
    });

    if (!p.images.length && p.featured_image) {
      var btn = document.createElement('button');
      btn.className = 'ps__thumb' + (thumbIdx === 0 ? ' is-active' : '');
      btn.type = 'button';
      btn.innerHTML = '<img src="' + p.featured_image + '" alt="' + p.title + '" class="ps-force-show" style="width: 100% !important; height: 100% !important; object-fit: cover !important; display: block !important; visibility: visible !important; opacity: 1 !important; position: absolute !important; top: 0 !important; left: 0 !important;">';
      var ii = thumbIdx++;
      newList.push({ type: 'image', src: p.featured_image, thumb: p.featured_image, alt: p.title });
      btn.addEventListener('click', function () { isFirstLoad = false; setImg(ii, false); });
      thumbsEl.appendChild(btn);
    }

    if (p.has_video && p.video) {
      var vBtn = document.createElement('button');
      vBtn.className = 'ps__thumb ps__thumb--video';
      vBtn.type = 'button';
      var poster = p.video.poster || '';
      vBtn.innerHTML = (poster ? '<img src="' + poster + '" alt="Video" class="ps-force-show" style="width: 100% !important; height: 100% !important; object-fit: cover !important; display: block !important; visibility: visible !important; opacity: 1 !important; position: absolute !important; top: 0 !important; left: 0 !important;">' : '') +
        '<span class="ps__thumb-play"><svg viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" fill="rgba(0,0,0,0.5)"/><path d="M6.5 5.5L11 8L6.5 10.5V5.5Z" fill="white"/></svg></span>';
      var vi = thumbIdx++;
      newList.push({ type: 'video', src: '', alt: 'Video', videoData: p.video });
      vBtn.addEventListener('click', function () { isFirstLoad = false; setImg(vi, false); });
      thumbsEl.appendChild(vBtn);
    }

    imgList = newList;
    renderProgress();

    if (videoWrap && p.has_video && p.video) {
      var vidEl = videoWrap.querySelector('video');
      if (vidEl && p.video.src) {
        vidEl.src = p.video.src;
        vidEl.poster = p.video.poster || '';
        vidEl.load();
      }
      var iframeEl = videoWrap.querySelector('iframe');
      if (iframeEl && p.video.external_id) {
        iframeEl.src = 'https://www.youtube.com/embed/' + p.video.external_id + '?autoplay=1&mute=1&loop=1';
      }
    }
  }

  /* ── Swatches ── */
  var swatchesLimit = cfg.swatchesVisible || 7;
  var multipackSwatchesLimit = 4;

  function applyMoreLess(container, limit, slim) {
    if (!container) return;
    if (limit == null) limit = swatchesLimit;
    var existingToggle = container.querySelector('.ps__swatches-toggle');
    if (existingToggle) existingToggle.remove();
    var items = Array.from(container.querySelectorAll('.ps__swatch, .swatch-input__label'));
    items.forEach(function (el) { el.style.order = ''; });
    if (items.length <= limit) {
      items.forEach(function (el) { el.style.display = ''; });
      return;
    }

    function isActive(el) {
      return el.classList.contains('is-active') ||
        (el.previousElementSibling && el.previousElementSibling.checked);
    }

    var expanded = false;

    function toggle(show) {
      var activeEl = null;
      var activeIdx = -1;
      items.forEach(function (el, i) {
        if (isActive(el)) { activeEl = el; activeIdx = i; }
      });

      items.forEach(function (el, i) {
        el.style.order = '';
        var hidden = !show && i >= limit && el !== activeEl;
        el.style.setProperty('display', hidden ? 'none' : '', hidden ? 'important' : '');
        var prev = el.previousElementSibling;
        if (prev && prev.tagName === 'INPUT') prev.style.setProperty('display', hidden ? 'none' : '', hidden ? 'important' : '');
      });

      if (!show && activeEl && activeIdx >= limit) {
        activeEl.style.order = '1';
        var activePrev = activeEl.previousElementSibling;
        if (activePrev && activePrev.tagName === 'INPUT') activePrev.style.order = '1';
      }
    }

    toggle(false);
    var toggleBtn = document.createElement('button');
    toggleBtn.className = 'ps__swatches-toggle' + (slim ? ' ps__swatches-toggle--slim' : '');
    toggleBtn.type = 'button';
    toggleBtn.style.order = '99';
    toggleBtn.textContent = slim ? '+' : 'More';
    toggleBtn.addEventListener('click', function () {
      expanded = !expanded;
      toggle(expanded);
      toggleBtn.textContent = expanded ? (slim ? '−' : 'Less') : (slim ? '+' : 'More');
    });
    container.appendChild(toggleBtn);
  }

  function renderSwatches(pack, activePid) {
    if (!swatchWrap) return;
    swatchWrap.innerHTML = '';
    var isMultipack = pack !== 'Single' && pack !== 'single';
    swatchWrap.classList.toggle('ps__swatches--multipack', isMultipack);
    var list = packProducts(pack);
    var isSingleWithColor = (pack === 'Single' || pack === 'single') && list.length === 1 && list[0].variants && list[0].variants[0].option2 != null && list[0].variants[0].option2 !== '';
    var singleOpts = cfg.single_color_options;
    var singleInputName = cfg.single_color_input_name;
    
    if (isSingleWithColor && singleOpts && singleOpts.length) {
      var p = list[0];
      var current = getCurrentVariant() || p.variants[0];
      var inputName = singleInputName || 'Color-2';
      singleOpts.forEach(function (item, idx) {
        var colorVal = item.value;
        var vMatch = findVariant(p, current.option1, colorVal, current.option3);
        var inputId = 'ps-swatch-' + sid + '-' + idx;
        var input = document.createElement('input');
        input.type = 'radio';
        input.id = inputId;
        input.name = inputName;
        input.value = colorVal;
        input.className = 'swatch-input__input' + (vMatch && !vMatch.available ? ' visually-disabled' : '');
        if (colorVal === current.option2) input.checked = true;
        input.setAttribute('data-option-value', colorVal);
        swatchWrap.appendChild(input);
        var label = document.createElement('label');
        label.htmlFor = inputId;
        label.title = colorVal;
        label.className = 'swatch-input__label swatch-input__label--square';
        label.style.position = 'relative';
        var swatchSpan = document.createElement('span');
        swatchSpan.className = 'swatch swatch--square';
        if (item.swatch_image) swatchSpan.style.setProperty('--swatch--background', 'url(' + item.swatch_image + ')');
        else if (item.swatch_rgb) swatchSpan.style.setProperty('--swatch--background', item.swatch_rgb);
        else swatchSpan.classList.add('swatch--unavailable');
        label.appendChild(swatchSpan);
        var nameSpan = document.createElement('span');
        nameSpan.className = 'swatch-name visually-hidden';
        nameSpan.textContent = colorVal;
        label.appendChild(nameSpan);
        swatchWrap.appendChild(label);
      });
      applyMoreLess(swatchWrap);
    } else if (isSingleWithColor) {
      var p = list[0];
      var current = getCurrentVariant() || p.variants[0];
      var colorValues = [];
      p.variants.forEach(function (v) {
        if (v.option2 && colorValues.indexOf(v.option2) === -1) colorValues.push(v.option2);
      });
      colorValues.forEach(function (colorVal) {
        var colorHasStock = p.variants.some(function (v) { return v.option2 === colorVal && v.available; });
        if (!colorHasStock) return;
        var vMatch = findVariant(p, current.option1, colorVal, current.option3);
        var btn = document.createElement('button');
        btn.className = 'ps__swatch' + (colorVal === current.option2 ? ' is-active' : '');
        btn.type = 'button';
        btn.title = colorVal;
        btn.setAttribute('data-option2', colorVal);
        if (vMatch && vMatch.featured_image) {
          var imgEl = document.createElement('img');
          imgEl.src = vMatch.featured_image.src || vMatch.featured_image;
          imgEl.alt = colorVal;
          imgEl.width = 100;
          imgEl.height = 100;
          imgEl.loading = 'lazy';
          btn.appendChild(imgEl);
        }
        swatchWrap.appendChild(btn);
      });
      applyMoreLess(swatchWrap);
    } else {
      list.forEach(function (p) {
        if (p.available === false) return;
        var btn = document.createElement('button');
        btn.className = 'ps__swatch' + (p.id === activePid ? ' is-active' : '');
        btn.type = 'button';
        btn.title = p.color_label || p.title;
        btn.setAttribute('data-product-id', p.id);
        if ((pack === 'Single' || pack === 'single') && p.color_hex) {
          btn.classList.add('ps__swatch--dot');
          btn.style.background = p.color_hex;
        } else {
          var imgEl = document.createElement('img');
          imgEl.src = p.featured_image;
          imgEl.alt = p.color_label || p.title;
          imgEl.width = 100;
          imgEl.height = 100;
          imgEl.loading = 'lazy';
          btn.appendChild(imgEl);
        }
        if (p.badge_text) {
          var badge = document.createElement('span');
          badge.className = 'ps__swatch-tag';
          badge.textContent = p.badge_text;
          btn.appendChild(badge);
        }
        swatchWrap.appendChild(btn);
      });
      applyMoreLess(swatchWrap, multipackSwatchesLimit, true);
    }
    
    if (swatchWrap) {
      var badgesToApply = [
        { text: cfg.firstSwatchBadge, bg: cfg.firstSwatchBg, color: cfg.firstSwatchText },
        { text: cfg.secondSwatchBadge, bg: cfg.secondSwatchBg, color: cfg.secondSwatchText },
        { text: cfg.thirdSwatchBadge, bg: cfg.thirdSwatchBg, color: cfg.thirdSwatchText },
        { text: cfg.fourthSwatchBadge, bg: cfg.fourthSwatchBg, color: cfg.fourthSwatchText }
      ];
      var swatches = swatchWrap.querySelectorAll('.ps__swatch, .swatch-input__label');
      
      badgesToApply.forEach(function(badge, idx) {
        if (badge.text && swatches[idx]) {
          var target = swatches[idx];
          if (!target.querySelector('.ps__swatch-tag')) {
            var badgeEl = document.createElement('span');
            badgeEl.className = 'ps__swatch-tag';
            badgeEl.textContent = badge.text;
            badgeEl.style.setProperty('background-color', badge.bg, 'important');
            badgeEl.style.setProperty('color', badge.color, 'important');
            badgeEl.style.setProperty('border-color', badge.bg, 'important');
            target.appendChild(badgeEl);
          }
        }
      });
    }
  }

  /* ── Price ── */
  function updatePrice(variantPrice, comparePrice, packQty) {
    variantPrice = variantPrice || 0;
    comparePrice = comparePrice || 0;
    packQty      = packQty || 1;

    if (priceEl) priceEl.textContent = money(variantPrice);

    var parsedCompare = comparePrice;

    if (compareEl) {
      var overrideText = '';
      if (activePack) {
        var attrSafe = 'data-override-' + activePack.toLowerCase().replace(' ', '-');
        overrideText = compareEl.getAttribute(attrSafe) || '';
      }

      if (overrideText) {
        compareEl.textContent = overrideText;
        compareEl.style.display = '';
        var num = parseFloat(overrideText.replace(/[^0-9.]/g, ''));
        if (!isNaN(num) && num > 0) {
          parsedCompare = Math.round(num * 100);
        }
      } else {
        if (comparePrice > variantPrice) {
          compareEl.textContent = money(comparePrice);
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }
    }
    
    if (promoTextEl && promoWrapper && !cfg.promoBadgeStatic) {
      if (parsedCompare > variantPrice) {
        var pct = Math.round((parsedCompare - variantPrice) * 100 / parsedCompare);
        var baseText = promoTextEl.getAttribute('data-base-text') || '';
        promoTextEl.textContent = baseText.replace('[savings]', pct);
        promoWrapper.style.display = '';
      } else {
        promoWrapper.style.display = 'none';
      }
    }

    if (saveBadge) {
      if (parsedCompare > variantPrice) {
        saveBadge.textContent = 'Save ' + Math.round((parsedCompare - variantPrice) * 100 / parsedCompare) + '%';
        saveBadge.style.display = '';
      } else {
        saveBadge.style.display = 'none';
      }
    }
    if (qtyEl) qtyEl.textContent = packQty;
    if (perEl) perEl.textContent = money(Math.round(variantPrice / packQty));
    if (qtyRow) qtyRow.style.display = packQty > 1 ? '' : 'none';
  }

  /* ── ATC ── */
  function updateAtc(available) {
    if (!atcBtn) return;
    var txt = atcBtn.querySelector('.btn_text');
    
    if (!sizeSelected) {
      atcBtn.disabled = true;
      if (txt) txt.textContent = 'Select a Size';
      return;
    }

    atcBtn.disabled = !available;
    if (txt) txt.textContent = available ? 'Add To Cart' : 'Sold Out';
  }

  /* ── Apply selected variant ── */
  function applyVariant(v, p) {
    if (!v || !p) return;
    
    if (sizeSelected && vidInput) vidInput.value = v.id;
    if (sizeLabel) {
      sizeLabel.textContent = sizeSelected ? mapSizeLabel(v.option1) : 'Choose a size.';
    }

    var hasOption3 = p.variants[0].option3 != null && p.variants[0].option3 !== '';
    var matVal = hasOption3 ? (v.option3 || '') : (v.option2 || '');
    
    if (materialLabel) materialLabel.textContent = matVal;
    if (subtitleMat) subtitleMat.textContent = matVal;

    if (colorVal) {
      var hasColorSwatches = swatchWrap && swatchWrap.querySelector('.ps__swatch[data-option2], input.swatch-input__input');
      colorVal.textContent = hasColorSwatches ? (v.option2 || p.color_label || '') : (p.color_label || '');
    }
    if (swatchWrap && v.option2 != null && v.option2 !== '') {
      var colorFieldset = swatchWrap.closest('.color-set');
      var inputName = colorFieldset ? colorFieldset.getAttribute('data-color-input-name') : (cfg.single_color_input_name || null);
      if (inputName) {
        var opts = swatchWrap.querySelectorAll('input[name="' + inputName + '"]');
        for (var o = 0; o < opts.length; o++) {
          if (opts[o].value === v.option2) { opts[o].checked = true; break; }
        }
      }
    }
    
    updateAtc(v.available);
    updatePrice(v.price, v.compare_at_price, p.pack_qty);

    /* ── Third custom price (per-product metafield) ── */
    if (thirdPriceEl) {
      var thirdVal = p.third_price || '';
      thirdPriceEl.textContent = thirdVal;
      thirdPriceEl.style.display = thirdVal ? '' : 'none';
    }

    /* ── DEBUG: show currently selected product + its metafield value ── */
    if (debugEl) {
      debugEl.textContent = 'DEBUG → selected product: "' + (p.title || '') +
        '" | third_custom_price: [' + (p.third_price || '') + ']';
    }
    
    if (sizesWrap) {
      sizesWrap.querySelectorAll('.ps__size-btn').forEach(function (b) {
        var opt1 = b.getAttribute('data-option1');
        var vMatch = findVariant(p, opt1, v.option2, v.option3);
        b.classList.toggle('is-active', sizeSelected && opt1 === v.option1);
        b.classList.toggle('is-sold-out', vMatch ? !vMatch.available : true);
      });
    }
    if (materialsWrap) {
      materialsWrap.querySelectorAll('.ps__material-btn').forEach(function (b) {
        var opt2 = b.getAttribute('data-option2');
        var opt3 = b.getAttribute('data-option3');
        var vMatch = opt3 != null ? findVariant(p, v.option1, v.option2, opt3) : findVariant(p, v.option1, opt2, v.option3);
        var isActive = (opt3 != null && opt3 === v.option3) || (opt2 != null && opt2 === v.option2);
        b.classList.toggle('is-active', isActive);
        b.classList.toggle('is-sold-out', vMatch ? !vMatch.available : true);
      });
    }
    if (swatchWrap) {
      swatchWrap.querySelectorAll('.ps__swatch[data-option2]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-option2') === v.option2);
      });
      swatchWrap.querySelectorAll('.ps__swatch[data-product-id]').forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.getAttribute('data-product-id'), 10) === p.id);
      });
    }

    if (v.featured_image_full && imgList.length) {
      var firstImgIdx = cfg.heroVideoPreview ? 1 : 0; 
      var matchIdx = -1;
      
      for (var mi = firstImgIdx; mi < imgList.length; mi++) {
        if (imgList[mi].type === 'image' && imgList[mi].src === v.featured_image_full) {
          matchIdx = mi; break;
        }
      }
      if (matchIdx === -1) {
        for (var mi = firstImgIdx; mi < imgList.length; mi++) {
          if (imgList[mi].type === 'image' && imgList[mi].thumb === v.featured_image) {
            matchIdx = mi; break;
          }
        }
      }
      if (matchIdx > firstImgIdx) {
        var moved = imgList.splice(matchIdx, 1)[0];
        imgList.splice(firstImgIdx, 0, moved);
        if (thumbsEl) {
          var thumbBtns = Array.from(thumbsEl.querySelectorAll('.ps__thumb'));
          if (thumbBtns[matchIdx] && thumbBtns[firstImgIdx]) {
            var movedThumb = thumbBtns[matchIdx];
            thumbsEl.removeChild(movedThumb);
            thumbsEl.insertBefore(movedThumb, thumbBtns[firstImgIdx]);
            thumbsEl.querySelectorAll('.ps__thumb').forEach(function (t, ti) {
              (function (idx) { t.onclick = function () { isFirstLoad = false; setImg(idx, false); }; })(ti);
            });
          }
        }
      }
      
      if (isFirstLoad && cfg.heroVideoPreview) {
        setImg(0, true);
      } else {
        setImg(firstImgIdx, false);
      }
    }
  }

  /* ── Sizes (option1 only) ── */
  function renderSizes(p) {
    if (!sizesWrap || !p.variants.length) return;
    var option1Values = [];
    p.variants.forEach(function (v) {
      if (option1Values.indexOf(v.option1) === -1) option1Values.push(v.option1);
    });
    sizesWrap.innerHTML = '';
    
    var current = p.variants[0]; 
    if (sizeSelected && vidInput && vidInput.value) {
      var id = parseInt(vidInput.value, 10);
      current = p.variants.find(function (v) { return v.id === id; }) || current;
    }

    option1Values.forEach(function (opt1) {
      var vMatch = findVariant(p, opt1, current.option2, current.option3);
      var btn = document.createElement('button');
      btn.className = 'ps__size-btn' + (sizeSelected && opt1 === current.option1 ? ' is-active' : '') + (vMatch && !vMatch.available ? ' is-sold-out' : '');
      btn.type = 'button';
      btn.textContent = opt1;
      btn.setAttribute('data-option1', opt1);
      btn.addEventListener('click', function () {
        isFirstLoad = false;
        dismissHeroVideo(); 
        sizeSelected = true; 
        var cur = getCurrentVariant() || p.variants[0];
        var v = findVariant(p, opt1, cur.option2, cur.option3);
        if (v) applyVariant(v, p);
      });
      sizesWrap.appendChild(btn);
    });
    
    applyVariant(current, p);
  }

  /* ── Materials (option2 or option3 depending on product) ── */
  function renderMaterials(p) {
    if (!materialsWrap || !p.variants.length) return;
    var v0 = p.variants[0];
    var hasOption3 = v0.option3 != null && v0.option3 !== '';
    var materialValues = [];
    p.variants.forEach(function (v) {
      var val = hasOption3 ? v.option3 : v.option2;
      if (val && materialValues.indexOf(val) === -1) materialValues.push(val);
    });
    if (!materialValues.length) { materialsWrap.innerHTML = ''; return; }
    materialsWrap.innerHTML = '';
    
    var current = p.variants[0];
    if (sizeSelected && vidInput && vidInput.value) {
       var id = parseInt(vidInput.value, 10);
       current = p.variants.find(function (v) { return v.id === id; }) || current;
    }
    
    var currentMaterial = hasOption3 ? current.option3 : current.option2;
    materialValues.forEach(function (matVal) {
      var vMatch = hasOption3 ? findVariant(p, current.option1, current.option2, matVal) : findVariant(p, current.option1, matVal, null);
      var btn = document.createElement('button');
      btn.className = 'ps__material-btn' + (matVal === currentMaterial ? ' is-active' : '') + (vMatch && !vMatch.available ? ' is-sold-out' : '');
      btn.type = 'button';
      btn.textContent = matVal;
      if (hasOption3) btn.setAttribute('data-option3', matVal); else btn.setAttribute('data-option2', matVal);
      btn.addEventListener('click', function () {
        isFirstLoad = false;
        dismissHeroVideo();
        var cur = getCurrentVariant() || p.variants[0];
        var v = hasOption3 ? findVariant(p, cur.option1, cur.option2, matVal) : findVariant(p, cur.option1, matVal, null);
        if (v) applyVariant(v, p);
      });
      materialsWrap.appendChild(btn);
    });
    applyVariant(current, p);
  }

  /* ── Load product ── */
  function loadProduct(p) {
    activeProduct = p;
    if (colorVal) colorVal.textContent = p.color_label || '';
    renderThumbs(p);
    
    if (isFirstLoad && cfg.heroVideoPreview) {
      setImg(0, true); 
    } else {
      var firstImageIdx = cfg.heroVideoPreview ? 1 : 0;
      setImg(firstImageIdx, false); 
    }
    
    renderSizes(p);
    renderMaterials(p);
  }

  /* ── Static offer badge: shown only for its configured pack ── */
  function updatePromoBadge() {
    if (!cfg.promoBadgeStatic || !promoWrapper) return;
    var gate = (cfg.promoBadgePack || '').toLowerCase();
    var show = !gate || (activePack || '').toLowerCase() === gate;
    promoWrapper.style.display = show ? '' : 'none';
  }

  /* ── Select pack ── */
  function selectPack(pack, isManualClick) {
    if (isManualClick) dismissHeroVideo();
    activePack = pack;
    updatePromoBadge();
    var p = defaultForPack(pack);
    if (!p) return;

    if (titleEl) titleEl.textContent = cfg.packTitles[pack] || p.title;

    document.querySelectorAll('#ps-pack-tabs-' + sid + ' .ps__pack-tab').forEach(function (tab) {
      var active = tab.getAttribute('data-pack') === pack;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    renderSwatches(pack, p.id);
    loadProduct(p);
  }

  /* ── Pack tab clicks ── */
  document.querySelectorAll('#ps-pack-tabs-' + sid + ' .ps__pack-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      isFirstLoad = false;
      selectPack(tab.getAttribute('data-pack'), true);
    });
  });

  /* ── Bundle-row prices (Kumori PDP design layer): each pack row shows
     compare-at struck out + price on the right, from that pack's default
     product. Whole-dollar prices drop the trailing .00 ($128, not $128.00).
     rowForceCompare: rows without a compare-at price fall back to
     pack qty × single-pair price so every row gets a strike-through.
     rowPerPair: the row's save text is replaced with the computed
     per-pair price (Single keeps its own text). ── */
  function moneyShort(cents) {
    return money(cents).replace(/\.00(?=\D|$)/, '');
  }
  var singlePairP = defaultForPack('Single');
  var singlePairPrice = 0;
  if (singlePairP && singlePairP.variants.length) {
    var spv = singlePairP.variants.find(function (x) { return x.available; }) || singlePairP.variants[0];
    if (spv) singlePairPrice = spv.price || 0;
  }
  document.querySelectorAll('#ps-pack-tabs-' + sid + ' .ps__pack-tab').forEach(function (tab) {
    var p = defaultForPack(tab.getAttribute('data-pack'));
    if (!p) return;
    var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
    if (!v) return;
    var qty = p.pack_qty || 1;
    var rowPrice = tab.querySelector('.ps__tab-price');
    var rowCmp = tab.querySelector('.ps__tab-compare');
    if (rowPrice) rowPrice.textContent = moneyShort(v.price);
    if (rowCmp) {
      var cmp = v.compare_at_price > v.price ? v.compare_at_price : 0;
      if (!cmp && cfg.rowForceCompare && singlePairPrice && qty > 1) {
        var derived = singlePairPrice * qty;
        if (derived > v.price) cmp = derived;
      }
      if (cmp) rowCmp.textContent = moneyShort(cmp);
      else rowCmp.style.display = 'none';
    }
    if (cfg.rowPerPair && qty > 1) {
      var perTxt = moneyShort(Math.round(v.price / qty)) + ' ' + (cfg.rowPerPairSuffix || '/ PP');
      var saveEl = tab.querySelector('.ps__tab-save');
      if (!saveEl) {
        saveEl = document.createElement('span');
        saveEl.className = 'ps__tab-save';
        var wrapEl = tab.querySelector('.ps__tab-pricewrap');
        if (wrapEl) tab.insertBefore(saveEl, wrapEl); else tab.appendChild(saveEl);
      }
      saveEl.textContent = perTxt;
    }
  });

  /* ── Arrow nav ── */
  if (prevBtn) prevBtn.addEventListener('click', function () { isFirstLoad = false; setImg(imgIdx - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { isFirstLoad = false; setImg(imgIdx + 1); });

  /* ── Mobile peek tap → jump to that image ── */
  if (peekWrap) {
    peekWrap.addEventListener('click', function () {
      var pIdx = parseInt(peekWrap.getAttribute('data-peek-idx') || '-1', 10);
      if (pIdx > -1) {
        isFirstLoad = false;
        setImg(pIdx, false);
      }
    });
  }

  /* ── Swipe on mobile ── */
  var galleryMain = el('ps-gallery-main-' + sid);
  var SWIPE_THRESHOLD = 45; 
  var HORIZONTAL_CLAIM_PX = 25; 
  var touchClaimed = false;
  if (galleryMain) {
    galleryMain.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchClaimed = false;
    }, { passive: true });
    galleryMain.addEventListener('touchmove', function (e) {
      if (touchClaimed) { e.preventDefault(); return; }
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;
      if (Math.abs(dx) > HORIZONTAL_CLAIM_PX && Math.abs(dx) > Math.abs(dy)) {
        touchClaimed = true;
        e.preventDefault();
      }
    }, { passive: false });
    galleryMain.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        isFirstLoad = false;
        setImg(dx < 0 ? imgIdx + 1 : imgIdx - 1);
      }
    }, { passive: true });
  }

  /* ── Modals logic ── */
  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    var box = modal.querySelector('.ps-modal__box');
    if (box) box.focus();
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
  }
  
  if (sgBtn && sgModal) {
    sgBtn.addEventListener('click', function () { openModal(sgModal); });
  }
  
  document.querySelectorAll('[data-modal-trigger]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var mId = btn.getAttribute('data-modal-trigger');
      var m = document.getElementById('ps-modal-' + mId);
      if (m) openModal(m);
    });
  });

  document.querySelectorAll('.ps-modal [data-close-modal]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var modal = e.target.closest('.ps-modal');
      if (modal) closeModal(modal);
    });
  });
  
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { 
      document.querySelectorAll('.ps-modal:not([hidden])').forEach(function(m) {
        closeModal(m);
      });
    }
  });

  /* ── Init server-rendered thumb clicks ── */
  if (thumbsEl) {
    var initList = [];
    thumbsEl.querySelectorAll('.ps__thumb').forEach(function (btn, i) {
      var mediaType = btn.getAttribute('data-media-type') || 'image';
      var hiRes = btn.getAttribute('data-img-src') || '';
      var loRes = btn.querySelector('img') ? btn.querySelector('img').getAttribute('src') : '';
      var alt   = btn.querySelector('img') ? btn.querySelector('img').alt : '';
      initList.push({ type: mediaType, src: hiRes || loRes, thumb: loRes, alt: alt });
      btn.addEventListener('click', function () { isFirstLoad = false; setImg(i, false); });
    });
    imgList = initList;
    renderProgress();
    if (imgList.length) setImg(0, true);

    /* Mobile peek: keep imgIdx in sync as the user finger-scrolls the carousel.
       Stride is derived from real DOM offsets so it works regardless of gap. */
    if (cfg.peekLayout) {
      thumbsEl.addEventListener('scroll', function () {
        if (window.innerWidth > 767) return;
        var thumbs = thumbsEl.querySelectorAll('.ps__thumb');
        if (!thumbs.length) return;
        var stride = thumbs.length > 1
          ? (thumbs[1].offsetLeft - thumbs[0].offsetLeft)
          : thumbs[0].offsetWidth;
        if (stride <= 0) return;
        var newIdx = Math.round(thumbsEl.scrollLeft / stride);
        if (newIdx !== imgIdx && newIdx >= 0 && newIdx < imgList.length) {
          imgIdx = newIdx;
          var item = imgList[newIdx];
          if (item && item.type === 'image' && item.src && mainImg) {
            mainImg.src = item.src;
            mainImg.alt = item.alt || '';
          }
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === newIdx); });
          syncProgress();
        }
      }, { passive: true });
    }
  }

  /* ── Init swatch / theme variant picker ── */
  if (swatchWrap) {
    swatchWrap.addEventListener('change', function (e) {
      var input = e.target;
      if (input.type === 'radio' && input.classList.contains('swatch-input__input')) {
        isFirstLoad = false;
        dismissHeroVideo(); 
        var option2 = input.value;
        if (activeProduct && option2) {
          var cur = getCurrentVariant() || activeProduct.variants[0];
          var v = findVariant(activeProduct, cur.option1, option2, cur.option3);
          if (v) applyVariant(v, activeProduct);
        }
        return;
      }
    });
    swatchWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.ps__swatch');
      if (!btn) return;
      isFirstLoad = false;
      dismissHeroVideo(); 
      
      var option2 = btn.getAttribute('data-option2');
      if (option2 != null && activeProduct) {
        var cur = getCurrentVariant() || activeProduct.variants[0];
        var v = findVariant(activeProduct, cur.option1, option2, cur.option3);
        if (v) applyVariant(v, activeProduct);
        return;
      }
      var pid = parseInt(btn.getAttribute('data-product-id'), 10);
      var p = products.find(function (x) { return x.id === pid; });
      if (!p) return;
      loadProduct(p);
      applyVariant(getCurrentVariant() || p.variants[0], p);
    });
  }

  /* ── Set initial activeProduct and sync ── */
  (function () {
    var initP = defaultForPack(cfg.defaultPack);
    if (initP) {
      loadProduct(initP);
    }
    var initIsSingle = (cfg.defaultPack || '').toLowerCase() === 'single';
    updatePromoBadge();
    if (!initIsSingle && swatchWrap) swatchWrap.classList.add('ps__swatches--multipack');
    applyMoreLess(swatchWrap, initIsSingle ? swatchesLimit : multipackSwatchesLimit, !initIsSingle);

    if (swatchWrap) {
      var badgesToApply = [
        { text: cfg.firstSwatchBadge, bg: cfg.firstSwatchBg, color: cfg.firstSwatchText },
        { text: cfg.secondSwatchBadge, bg: cfg.secondSwatchBg, color: cfg.secondSwatchText },
        { text: cfg.thirdSwatchBadge, bg: cfg.thirdSwatchBg, color: cfg.thirdSwatchText },
        { text: cfg.fourthSwatchBadge, bg: cfg.fourthSwatchBg, color: cfg.fourthSwatchText }
      ];
      var swatches = swatchWrap.querySelectorAll('.ps__swatch, .swatch-input__label');
      
      badgesToApply.forEach(function(badge, idx) {
        if (badge.text && swatches[idx]) {
          var target = swatches[idx];
          if (!target.querySelector('.ps__swatch-tag')) {
            var badgeEl = document.createElement('span');
            badgeEl.className = 'ps__swatch-tag';
            badgeEl.textContent = badge.text;
            badgeEl.style.setProperty('background-color', badge.bg, 'important');
            badgeEl.style.setProperty('color', badge.color, 'important');
            badgeEl.style.setProperty('border-color', badge.bg, 'important');
            target.appendChild(badgeEl);
          }
        }
      });
    }
  }());

  /* ── Inherit pack settings (default pack, tab order, titles) from the
        topmost pack-selector on this page/template ── */
  function topSelectorCfg() {
    var scripts = document.querySelectorAll('script[id^="ps-data-"]');
    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].id === 'ps-data-' + sid) continue; /* skip self */
      try { return JSON.parse(scripts[i].textContent); } catch (e) { return null; }
    }
    return null;
  }
  function applyInheritedPackSettings() {
    if (!cfg.inheritPackSettings) return;
    var top = topSelectorCfg();
    if (!top) return;

    /* 0) Product data (collection + single product) — adopt the top selector's
          product set so the swatches, gallery, price and color options all
          mirror it. Reassigning `products` updates every helper that closes
          over it (packProducts, renderSwatches, defaultForPack…). */
    if (top.products && top.products.length) products = top.products;
    cfg.single_color_options    = top.single_color_options;
    cfg.single_color_input_name = top.single_color_input_name;

    /* 1) Pack titles — adopt the top selector's titles so the heading matches. */
    if (top.packTitles) cfg.packTitles = top.packTitles;

    /* 2) Pack tab order + visibility — reorder/hide this section's existing
          tabs to match the top selector's pack order. */
    var tabsWrap = document.getElementById('ps-pack-tabs-' + sid);
    if (tabsWrap && top.packOrder) {
      var order = String(top.packOrder).split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      var tabEls = Array.prototype.slice.call(tabsWrap.querySelectorAll('.ps__pack-tab'));
      order.forEach(function (packLower) {
        for (var i = 0; i < tabEls.length; i++) {
          if ((tabEls[i].getAttribute('data-pack') || '').toLowerCase() === packLower) {
            tabsWrap.appendChild(tabEls[i]); /* move into the inherited order */
            break;
          }
        }
      });
      tabEls.forEach(function (t) {
        var dp = (t.getAttribute('data-pack') || '').toLowerCase();
        t.style.display = order.indexOf(dp) === -1 ? 'none' : '';
      });
    }

    /* 3) Default selected pack — replay a real click on the matching tab so the
          title, price, swatches and gallery all fully update (case-insensitive). */
    var pack = top.defaultPack;
    if (pack) {
      var match = null;
      document.querySelectorAll('#ps-pack-tabs-' + sid + ' .ps__pack-tab').forEach(function (tab) {
        if (!match && (tab.getAttribute('data-pack') || '').toLowerCase() === String(pack).toLowerCase()) match = tab;
      });
      /* Matching tab → replay a real click (updates everything). No matching tab
         (collections expose different packs) → render the product directly. */
      if (match) match.click();
      else selectPack(pack, false);
    }
  }
  /* ── URL deep link: ?pack=8-Pack selects that pack tab on load;
        &style=<product handle or id> additionally selects that exact style
        within the pack (falls back gracefully if not found). Runs after
        inherited settings so it wins over the template's default pack. ── */
  function applyUrlDeepLink() {
    var q, pk, st;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
    pk = q.get('pack'); st = q.get('style');
    if (!pk && !st) return;
    var target = null;
    if (st) {
      var stLower = String(st).toLowerCase();
      for (var i = 0; i < products.length; i++) {
        if (String(products[i].handle || '').toLowerCase() === stLower || String(products[i].id) === st) { target = products[i]; break; }
      }
      if (target && !pk) pk = target.pack_size;
    }
    if (pk) {
      var match = null;
      document.querySelectorAll('#ps-pack-tabs-' + sid + ' .ps__pack-tab').forEach(function (tab) {
        if (!match && (tab.getAttribute('data-pack') || '').toLowerCase() === String(pk).toLowerCase()) match = tab;
      });
      if (match) match.click();
      else selectPack(pk, false);
    }
    if (target) {
      renderSwatches(target.pack_size || activePack, target.id);
      loadProduct(target);
      applyVariant(getCurrentVariant() || target.variants[0], target);
    }
  }
  function bootInheritedAndDeepLink() {
    applyInheritedPackSettings();
    applyUrlDeepLink();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootInheritedAndDeepLink);
  } else {
    bootInheritedAndDeepLink();
  }
  /* Re-apply when the theme editor reloads a section so edits to the top
     selector reflect here without a full page refresh. */
  document.addEventListener('shopify:section:load', function () { applyInheritedPackSettings(); });

};
